import { useMemo } from 'react';

import { useSaveProductShippingDefaults } from '../fulfillment-planner/shipping-default-button/use-save-product-shipping-defaults';
import { useEntitiesFulfillmentPlan } from './entities/selectors/fulfillment-plans';

const useSaveProductShippingData = (fulfillmentPlanId) => {
  const { asyncSaveShippingDefaults } = useSaveProductShippingDefaults(fulfillmentPlanId);
  const fulfillmentPlan = useEntitiesFulfillmentPlan(fulfillmentPlanId);
  const cswProductId = fulfillmentPlan?.items?.[0]?.productId || '';
  const isSingleOrder = fulfillmentPlan?.items?.length === 1;
  const isServiceCollectionSelected = fulfillmentPlan?.labelConfiguration?.serviceCollectionGuid;

  return useMemo(
    () => ({
      asyncSaveShippingDefaults,
      cswProductId,
      isSingleOrder,
      isServiceCollectionSelected,
    }),
    [asyncSaveShippingDefaults, cswProductId, isSingleOrder, isServiceCollectionSelected],
  );
};

export { useSaveProductShippingData };
